export default __webpack_public_path__ + "static/media/intro-video.615a3a15.mp4";